// src/components/BlogIndex.js

import React from 'react';
import { Box, Typography, Container, Grid, Card, CardContent, CardActionArea } from '@mui/material';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const posts = [
  {
    slug: 'best-free-gift-list-app-for-families',
    title: 'The Best Free Gift List App for Families in 2026',
    excerpt: 'Discover how to organize gift giving across your whole family with a free app that handles wish lists, secret purchases, and spending tracking.',
    date: '2026-02-22',
  },
  {
    slug: 'track-holiday-gift-spending',
    title: 'How to Track Your Holiday Gift Spending Without a Spreadsheet',
    excerpt: 'Stop losing track of what you spent on gifts. Learn how a gift spending dashboard can help you stay on budget across every event and person.',
    date: '2026-02-22',
  },
  {
    slug: 'shared-lists-for-couples',
    title: 'Shared Lists for Couples: Grocery, Packing, and To-Do',
    excerpt: 'The best free shared list apps for couples who want to collaborate on grocery shopping, trip packing, and household to-dos.',
    date: '2026-02-22',
  },
];

function BlogIndex() {
  return (
    <div>
      <Helmet>
        <title>ListLink Blog - Gift Giving Tips, List Organization & More</title>
        <meta
          name="description"
          content="Tips and guides on gift list organization, holiday spending tracking, shared lists for families and couples, and getting the most out of ListLink."
        />
        <meta
          name="keywords"
          content="gift list tips, holiday spending, shared lists, gift giving guide, family gift organization"
        />
        <meta property="og:title" content="ListLink Blog - Gift Giving Tips & List Organization" />
        <meta property="og:description" content="Tips and guides on gift list organization, holiday spending tracking, and shared lists for families and couples." />
        <meta property="og:url" content="https://list-link.com/blog" />
        <meta property="og:type" content="website" />
        <link rel="canonical" href="https://list-link.com/blog" />
      </Helmet>

      <Box sx={{ py: 8, backgroundColor: '#f5f5f5' }}>
        <Container maxWidth="md">
          <Typography variant="h3" component="h1" gutterBottom>
            ListLink Blog
          </Typography>
          <Typography variant="h6" color="textSecondary" paragraph>
            Tips and guides on gift giving, list organization, and getting the most out of ListLink.
          </Typography>
        </Container>
      </Box>

      <Container maxWidth="md" sx={{ py: 6 }}>
        <Grid container spacing={4}>
          {posts.map((post) => (
            <Grid item xs={12} key={post.slug}>
              <Card variant="outlined">
                <CardActionArea component={Link} to={`/blog/${post.slug}`}>
                  <CardContent>
                    <Typography variant="caption" color="textSecondary">
                      {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </Typography>
                    <Typography variant="h5" component="h2" gutterBottom>
                      {post.title}
                    </Typography>
                    <Typography variant="body1" color="textSecondary">
                      {post.excerpt}
                    </Typography>
                  </CardContent>
                </CardActionArea>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
    </div>
  );
}

export default BlogIndex;
